<div class="dialog">
  <ng-content></ng-content>
</div>

@if (!hideCloseAllBtn) {
  <celum-icon class="dialog_close-all-btn" data-test-close-all-dialogs [configuration]="closeAllIconConfig" (click)="closeAll($event)"></celum-icon>
}
